import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import AnimationStyle from '../styles/pages/Animations.module.scss'
import Loader from '../components/layout/Loader'
import { Box, Typography, List, ListItem , Avatar} from '@mui/material'
import arrow from '../shared/images/arrow-down.svg'
import PageHeader from '../components/layout/PageHeader'
// - IMPORT API
import { useGetAllAnimationsQuery } from '../services/AnimationsAPI'
import { SingleAnimation } from '../utils/Interface'
import { useTranslation } from 'react-i18next';
const AnimationsPage: React.FC = () => {
    const { t, i18n  } = useTranslation();
    // Use start of today (00:00) in ISO format to fetch animations >= today
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayIso = today.toISOString();

    const {
        data: animationsData,
        error: animationsError,
        isLoading: animationsLoading,
        refetch
    } = useGetAllAnimationsQuery({ date: todayIso })


     // Utilisation de useEffect pour relancer la requête chaque fois que le composant est monté
  useEffect(() => {
    refetch(); // Rafraîchit les données à chaque fois que la page est visitée
  }, [refetch]);

    // - Check
    if (animationsError) {
        console.log(animationsError)
        console.log(animationsData)
        return <div>Error occurred while fetching restaurants.</div>
    }

    // - Wait until the data is loaded
    if (animationsLoading) {
        return <Loader />
    }

    // - Parse
    // - Filter for future animations
    const futureAnimations = animationsData?.data.filter((item: SingleAnimation) => {
        const animationDate = new Date(item.endDate).getTime()
        console.log(animationDate, Date.now(), animationDate > Date.now(), item.cancelled)
        return animationDate > Date.now()
    })

    return (
        <div className={AnimationStyle.AnimationsContainer}>
            <PageHeader backTo='/mon-compte' title={t('our_animations')} subtitle={t('our_animations_sub')} />
            <div className={AnimationStyle.CardContainer}>
                {Array.isArray(futureAnimations) && futureAnimations.length > 0 ? (
                    <>
                        
                        {futureAnimations.map((item: SingleAnimation, index) => (
                            <ListItem
                                key={index}
                                className={`${AnimationStyle.AnimationItem} ${item.cancelled ? AnimationStyle.isCancelled : ''}`}
                                component={item.cancelled ? "div" : Link}
                                to={item.cancelled ? undefined : `/reserve-animation/${item.id}`}
                            >
                                {item.cancelled && <div className={AnimationStyle.CancelledBadge}>{t('Animation_cancelled')}</div>}
                                <div className={AnimationStyle.AnimationContent}>
                                    <img
                                        src={String(String(process.env.REACT_APP_BASE_URL) + item.images?.[0]?.url) || 'default-image.png'}
                                        alt={item.title}
                                        className={AnimationStyle.AnimationImage}
                                    />
                                    <div className={AnimationStyle.AnimationInfo}>
                                        <div className={AnimationStyle.Lieu}>Les Settons</div>
                                        <div>
                                        <Typography variant="body2" className={AnimationStyle.strong}>{item.title}</Typography>
                                        <Typography variant="body2" className={AnimationStyle.thin}>
                                            {new Date(item.date).toLocaleDateString(i18n.language, {
                                                day: 'numeric',
                                                month: 'short',
                                            })}{' '}
                                            - {new Date(item.date).toLocaleTimeString(i18n.language, {
                                                hour: '2-digit',
                                                minute: '2-digit',
                                            })}
                                        </Typography>
                                        <Typography variant="body2" className={AnimationStyle.thin}>
                                        {item.nbParticipants} {item.nbParticipants <= 1 ? t('participant') : t('participant') + 's'}
                                        </Typography>

                                        </div>
                                        <Typography variant="body2" className={AnimationStyle.thin}>
                                            {item.price != null && item.price > 0 ? `${item.price}€` : t('free')}
                                        </Typography>
                                    </div>
                                </div>
                                <img src={arrow} alt='arrow' className={AnimationStyle.ArrowIcon} />
                            </ListItem>
                        ))}
                    </>
                ) : (
                    <Typography variant="body2" className={AnimationStyle.noAnimationsMessage}>
                        {t('no_animation')}
                    </Typography>
                )}
            </div>
        </div>
    )
}

export default AnimationsPage